import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Config from '../utils/Config';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-links">
          <button type="button" className={location.pathname === "/about" ? "active-link-footer" : ""} onClick={() => navigate('/about')}>About</button>
          <button type="button" className={location.pathname === "/terms" ? "active-link-footer" : ""} onClick={() => navigate('/terms')}>Terms of Use</button>
          <button type="button" className={location.pathname === "/privacy" ? "active-link-footer" : ""} onClick={() => navigate('/privacy')}>Privacy Policy</button>
          <button type="button" className={location.pathname === "/legal" ? "active-link-footer" : ""} onClick={() => navigate('/legal')}>Legal</button>
          <button type="button" className={location.pathname === "/hosting-terms" ? "active-link-footer" : ""} onClick={() => navigate('/hosting-terms')}> Website Hosting Subscription Terms</button>
          <button type="button" className={location.pathname === "/hosting-refunds" ? "active-link-footer" : ""} onClick={() => navigate('/hosting-refunds')}> Cancellation &amp; Refund Policy</button>
        </div>
        <div className="footer-copy">
          &copy; {new Date().getFullYear()} {Config.APP.NAME}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;